<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Add Files"
    :disabled="inProcess"
  >
    <b-form @submit.prevent="save">
      <b-form-group label="Files:">
        <b-form-file
          multiple
          v-model="files"
          placeholder="Choose a file..."
          drop-placeholder="Drop file here..."
          :disabled="inProcess"
        />
      </b-form-group>
      <b-form-group v-if="inProcess">
        <div class="uploading">
          <LoadingSpinner
            color="#bbb"
            size="32"
          />
          <span>Uploading...</span>
        </div>
      </b-form-group>
      <b-button
        variant="success"
        type="submit"
        :disabled="inProcess"
        >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// helpers
import eventBus from '@/helpers/event-bus'
import db from '@/services/db'
// components
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  props: [
    'gridId', 'rowKey',
    'cellKey', 'options'
  ],
  components: {
    LoadingSpinner
  },
  data () {
    return {
      files: [],
      inProcess: false
    }
  },
  computed: {
    ...mapState([
      'currentDash'
    ]),
    modalKey () {
      return `addFilesModal-${this.gridId}-${this.rowKey}-${this.cellKey}`
    }
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    save () {
      this.inProcess = true

      const data = {
        dashId: this.currentDash,
        files: this.files,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        options: this.options,
        curFiles: $dataGrid(this.gridId)[this.rowKey][this.cellKey]
      }

      db.dataGrid.data.uploadFiles(data, () => {
        this.inProcess = false
        this.files = []

        this.close()
      })
    }
  },
  mounted () {
    if (this.$refs[this.modalKey]) {
      $(this.$refs[this.modalKey]['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs[this.modalKey]) {
      $(this.$refs[this.modalKey]['$el']).remove()
    }
  }
}
</script>

<style lang="scss" scoped>
.uploading {
  display: flex;
  align-items: center;
  > div {
    margin-right: 10px;
  }
}
</style>

